import React, { Fragment, useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { MainDrawer } from '../../../CommonComponent/MainDrawer';
import { DefaultSkillRoleList } from './DefaultSkillRoleList ';

export const SkillProficiencyDrawer: React.FC<any> = (props: any) => {
	const { rolesData, handleSaveClick, openRoles, allProficiency } = props;
	const { t } = useTranslation();
	const [checkedUser, setCheckedUser] = useState<any>([]);
	const [disabledUsers, setDisabledUsers] = useState<any>([]);

	useEffect(() => {
		if (openRoles && openRoles.open) {
			if (
				openRoles &&
				openRoles.data &&
				openRoles.data.performanceRoleResponsesUsers &&
				openRoles.data.performanceRoleResponsesUsers.length > 0
			) {
				const userList = openRoles.data.performanceRoleResponsesUsers.map((user: any) => ({
					...user,
					checked: true,
				}));
				setCheckedUser(userList);
			}
			if (allProficiency && allProficiency.length > 0) {
				let disabledListCopy: any[] = [];
				allProficiency.forEach((item: any) => {
					if (item?.proficiencyScaleId !== openRoles.data.proficiencyScaleId && item.performanceRoleResponsesUsers) {
						disabledListCopy = disabledListCopy.concat(
							item.performanceRoleResponsesUsers.map((user: any) => ({
								...user,
								checked: true,
							}))
						);
					}
				});
				setDisabledUsers(disabledListCopy);
			}
		}
	}, [openRoles]);

	const handleDrawerClose = (event: any, type: string) => {
		console.log(checkedUser);
		handleSaveClick(event, type, checkedUser);
	};

	return (
		<>
			<MainDrawer
				open={true}
				transitionDuration={{ enter: 500, exit: 1000 }}
				children={
					<Box className='drawer-inner-content'>
						<DefaultSkillRoleList
							t={t}
							{...props}
							rolesData={rolesData}
							checkedUser={checkedUser}
							setCheckedUser={setCheckedUser}
							disabledUsers={disabledUsers}
						/>
					</Box>
				}
				saveButtonText={t('saveBtn')}
				rightCloseBtn={true}
				drawerClassName={'main-drawer-panel main-drawer-subpanel'}
				handleDrawerClose={(event: any) => handleDrawerClose(event, 'close')}
				handleSaveClick={(event: any) => handleDrawerClose(event, 'save')}
				handleCancelClick={(event: any) => handleDrawerClose(event, 'cancel')}
			/>
		</>
	);
};
